import { createGatsbyPageComponent } from '@shapeable/ui';
import { graphql } from 'gatsby';
import { ChallengeLayout } from '../../components/entities/challenge-layout';
export default createGatsbyPageComponent('Challenge', {
  layout: ChallengeLayout
});

export const QUERY = graphql`
query ChallengeQuery($id: ID!) {
  platform { challenge(id: $id) {
    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    openGraph { 
      id title 
      description { plain text }
      image { 
        id url url2x 
        thumbnails { 
          id bubbleLarge { id url url2x }
          mainBanner { id url url2x }
          halfBanner { id url url2x }
        }
      } 
    }
    slices {
      id name slug label updated
      title 
      titleRich { id text }
      layout { id name slug component }
      themeMode { id name slug }
      openGraph {
        id
        image { url thumbnails { large { url } bubble { url url2x } } }
      }
      headerFontType { internalName }
      bodyFontType { internalName }
      disabled
      connectedEntities { name label internalName }
      entityLayout { internalName }
      created updated
      outro { id text }
      intro { id text }
      content { 
        id plain text 
        linkEmbeds { 
            id name _label url slug __typename
            image { id url width height }
          } 
        linkRichEmbeds { 
          id name _label url slug __typename
          image { id url width height }
        }
      }
      email
      phone
      twitter
      threads
      linkedin
      backgroundColor { id value }
      color { id value }
      teams { id name slug __typename _schema { label pluralLabel } }
      objectives { id name slug __typename type { id name slug __typename } }
      icon { id slug name component }
      advertisements {
        id name slug url __typename
        description { id text }
        image {
          image { id url url2x type width height }
          landscapeImage { url url2x width height }
          tabletImage { id url url2x width height }
          portraitImage { id url url2x width height }
        }
      }
      embeds {
        citations {
          slug url name authors { id name slug } 
          authorShowsEtAl edition publication accessDate 
          startPage volume footnoteNumber year
        }
        posts {
          id name slug path
          openGraph {
            title description { plain(truncate: {words: 20}) }
            image { url url2x type }
          }
        }
        advertisements {
          id name slug url __typename
          description { id text }
          image {
            image { id url url2x type width height }
            landscapeImage { url url2x width height }
            tabletImage { id url url2x width height }
            portraitImage { id url url2x width height }
          }
        }
        imageAssets {
          id
          slug
          image {
            id url url2x width height type 
          }
        }
      }
      people {
        id name slug path __typename
        organisation { id name }
        linkedin
        position
        openGraph { id image { thumbnails { bubble { url url2x } card { url url2x } } } }
      }
      posts { 
        id name slug path __typename _schema { label  pluralLabel }
        type { id name slug }
        typeLabel
        openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
      }
      links {
        __typename
        id
        name
        page {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        post {
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
          taxonomyLabel
          color {
            id
            name
            value
          }
          people {
            
              
            
                id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
            
              
              
                    openGraph { 
                      id title 
                      
                      image { 
                        id url url2x 
                        thumbnails { 
                          id bubbleMedium { id url url2x }
                        }
                        
                      } 
                    }
                  
            
          }
          authors {
            
              
            
                id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
            
              
              
                    openGraph { 
                      id title 
                      
                      image { 
                        id url url2x 
                        thumbnails { 
                          id bubbleMedium { id url url2x }
                        }
                        
                      } 
                    }
                  
            
          }
        }
        video {
          taxonomyLabel
          color {
            id
            name
            value
          }
          people {
            
              
            
                id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
            
              
              
                    openGraph { 
                      id title 
                      
                      image { 
                        id url url2x 
                        thumbnails { 
                          id bubbleMedium { id url url2x }
                        }
                        
                      } 
                    }
                  
            
          }
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        event {
          taxonomyLabel
          color {
            id
            name
            value
          }
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        feedEntry {
          color {
            id
            name
            value
          }
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        organisation {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        person {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        economy {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        product {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        team {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        podcast {
          taxonomyLabel
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
        reflection {
          typeLabel
          taxonomyLabel
          authors {
            
              
            
                id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
            
              
              
                    openGraph { 
                      id title 
                      
                      image { 
                        id url url2x 
                        thumbnails { 
                          id bubbleMedium { id url url2x }
                        }
                        
                      } 
                    }
                  
            
          }
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          
                openGraph { 
                  id title 
                  description { text }
                  image { 
                    id url url2x 
                    thumbnails { 
                      id card { id url url2x }
                    }
                    
                  } 
                }
              
        }
      }
      feedEntries {
        name id slug path url __typename _schema { label pluralLabel }
        type { id name slug }
        typeLabel
        openGraph { id title image { url url2x thumbnails { full { url url2x } } } }
      }
      pages {
        id name slug path __typename _schema { label pluralLabel }
        type { id name slug }
        typeLabel
        openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
      }
      events {
        
          
        
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
        
          
          
                openGraph { 
                  id title 
                  
                  image { 
                    id url url2x 
                    thumbnails { 
                      id bubbleMedium { id url url2x }
                    }
                    
                  } 
                }
              
        
      }
    }
      description { id text }
      embeds {
        citations {
          slug url name authors { id name slug } 
          authorShowsEtAl edition publication accessDate 
          startPage volume footnoteNumber year
        }
        posts {
          id name slug path
          openGraph {
            title description { plain(truncate: {words: 20}) }
            image { url url2x type }
          }
        }
        imageAssets {
          id
          slug
          image {
            id url url2x width height type 
          }
        }
      }
      banner {
        id
        thumbnail { url } 
        image { 
          thumbnails {
            mainBanner { id url }
          }
          url 
        }
      }
      feedEntries {
        id slug path url name __typename _schema { label pluralLabel }
        types { id name slug }
        openGraph { 
          title description { plain }
          image { url thumbnails { large { url } } }
        }
      }
      posts {
        id slug name __typename path
        openGraph { 
          title description { plain }
          image { url thumbnails { large { url } } }
        }
      }
      pages {
        __typename id name path slug title subtitle pretitle 
        openGraph { description { id plain } image { url } }
        intro { id text }
        orderNumber
        type { id name slug }
        openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
      }
    
    backgroundImage {
      id 
      name
      portraitImage { url url2x }
      tabletImage { url url2x }
      landscapeImage { url url2x }
      largeImage { url url2x }
      image {
        url
      }
    }
    icon { id name component }
    color { id name value }
  } }
}
`;
